module.exports = __webpack_public_path__ + "static/img/box_def.56e03c50.svg";